module.exports = __webpack_public_path__ + "img/dp-dy-sy1.7760bf59.png";